import { type JSX } from "react";
import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import { requiredValidation } from "@via/utils/form-validators.tsx";

export default function CreateGitLabToken({ control }): JSX.Element {
  return (
    <>
      <FormInputComponent
        control={control}
        name="name"
        label="Token Name"
        placeholder="Enter Token Name"
        validations={requiredValidation("Token Name")}
        showRequiredField
      />
      <FormInputComponent
        control={control}
        name="credentialData.username"
        label="Account Username"
        placeholder="Enter Account Username"
        validations={requiredValidation("Account Username")}
        showRequiredField
      />
      <FormInputComponent
        control={control}
        name="credentialData.email"
        label="Account Email"
        placeholder="Enter Your Account Email"
        validations={requiredValidation("Email")}
        showRequiredField
      />
      <div>
        <FormInputComponent
          control={control}
          name="credentialData.token"
          label="Token"
          placeholder="Enter Your Token"
          validations={requiredValidation("Token")}
          showTooltipIcon
          tooltipText="Token will be used for downloading, creating and updating repositories."
          showRequiredField
        />
      </div>
      <div>
        <FormInputComponent
          control={control}
          name="credentialData.server"
          label="Server"
          placeholder="Enter Your Server"
          showTooltipIcon
          tooltipText="Required only for private repository servers. Server name including the protocol prefix e.g. https://github.com"
        />
      </div>
      <div>
        <FormInputComponent
          control={control}
          name="credentialData.endpoint"
          label="Endpoint"
          placeholder="Enter Your Endpoint"
          showTooltipIcon
          tooltipText="Required only for private repository servers. Repository API endpoint URL e.g. https://api.github.com (default: the same as Server value)"
        />
      </div>
    </>
  );
}
